export function getPage() {
  var page = window.getCnLowcodeStoreItem('page') || {};
  return page;
}
export function getEnv() {
  var env = window.getCnLowcodeStoreItem('env') || 'prod';
  return env;
}
export function getEnvText() {
  var envText = window.getCnLowcodeStoreItem('envText') || '线上';
  return envText;
}